import React from "react";
import ConfirmationDialog from "src/components/common/ConfirmationDialog";

export default function DeleteItemPopover({ fooditem = {}, open, handleDeleteItem, handleCloseDeleteItemDialog, menuName = "", itemName = "" }) {
  return <ConfirmationDialog
    open={open}
    title="Remove menu item?"
    description={`Are you sure you want to delete "${itemName}" from "${menuName}"?`}
    onClose={handleCloseDeleteItemDialog}
    onConfirm={() => handleDeleteItem(menuName, fooditem.sid ?? fooditem.id)}
  />;
}
